<template>
    <component :is="component" class="uik-headline__wrapper">
        <slot></slot>
    </component>
</template>

<script>
export default {
    name: "UikHeadline",
    props: {
        component: { type: String, default: "h3" },
        margin: { type: Boolean, default: false }
    }
}
</script>

<style lang="scss">
.uik-headline__wrapper {
  font-size: 1.625rem;
  line-height: 2.375rem;
  font-weight: 400;
}
</style>
